/* eslint-disable max-len,vue/max-len */
export const school = [
  {
    title: 'Какие документы нужны для поступления?',
    body: `
      <p>
        Базовый пакет документов включает: паспорт родителя и&nbsp;ребенка, свидетельство о&nbsp;рождении
        ребенка, СНИЛС, личная карта обучающегося и&nbsp;аттестат об&nbsp;окончании 9-го класса
        (для поступающих в&nbsp;10&ndash;11&nbsp;класс). Оставьте заявку, и&nbsp;мы&nbsp;подробно расскажем,
        какие документы потребуются и&nbsp;как их&nbsp;собрать.
      </p>
    `,
  },
  {
    title: 'Как перевести ребенка на&nbsp;семейное обучение?',
    body: `
      <p>
        Сперва предупредите директора вашей школы о&nbsp;переходе. Затем напишите уведомление
        и&nbsp;оповестите Департамент образования вашего города или округа о&nbsp;вашем решении.
        После определитесь со&nbsp;школой, куда вы&nbsp;прикрепитесь, чтобы проходить аттестации
        и&nbsp;экзамены. Прикрепиться можно к&nbsp;онлайн-школе «Синергия»,
        мы&nbsp;с&nbsp;радостью вам в&nbsp;этом поможем.
      </p>
      <p>
        Также в&nbsp;нашей школе можно учиться заочно, в&nbsp;этом случае вам не&nbsp;нужно
        будет переводиться на&nbsp;семейное обучение, поступить на&nbsp;заочную форму
        также просто, как сменить школу, а&nbsp;мы&nbsp;позаботимся, чтобы поступление
        прошло быстро и&nbsp;комфортно.
      </p>
    `,
  },
  {
    title: 'Какие различия между заочной и&nbsp;семейной формой обучения?',
    body: `
      <p>
        Заочная форма подразумевает, что ребенок зачислен в&nbsp;нашу школу с&nbsp;первого дня
        обучения, переход к&nbsp;нам на&nbsp;&laquo;заочку&raquo; юридически эквивалентен
        переходу ребенка в&nbsp;другую классическую школу. В&nbsp;9&nbsp;и&nbsp;11&nbsp;классах
        ученикам заочной форме необходимо будет приехать на&nbsp;ОГЭ или ЕГЭ в&nbsp;Москву.
        Наши ученики-заочники получают московский аттестат гос. образца Университета Синергия.
      </p>
      <p>
        Семейная форма обучения подразумевает, что ребенок переведен на&nbsp;семейное обучение
        и&nbsp;за&nbsp;его обучение отвечает семья. Чтобы не&nbsp;обучать ребенка ежедневно
        самостоятельно, родители могут перевести ребенка на&nbsp;семейную форму обучения,
        но&nbsp;доверить его обучение лицензированной удобной онлайн-школе с&nbsp;сильными
        преподавателями и&nbsp;проверенными материалами по&nbsp;ФГОС.
      </p>
      <p>
        По&nbsp;закону родители могут сами обучать ребенка, но&nbsp;не&nbsp;могут его
        аттестовать, поэтому на&nbsp;время прохождения аттестации ребенку, который находится
        на&nbsp;семейном обучении, необходимо прикрепиться к&nbsp;школе: прикрепиться можно
        к&nbsp;нашей онлайн-школе или к&nbsp;любой другой школе, например, по&nbsp;месту
        жительства. Выпускник получит аттестат именно той школы, в&nbsp;которой сдавал экзамены.
      </p>

      <p>
        На&nbsp;любой форме обучения в&nbsp;онлайн-школе вы&nbsp;можете посещать занятия, вам
        открыт доступ ко&nbsp;материалам на&nbsp;платформе, вам также будет доступен весь
        сервис согласно выбранному тарифу (Премиум, Комфорт или Лайт).
      </p>
    `,
  },
  {
    title: 'Как проходят экзамены в&nbsp;онлайн-школе?',
    body: `
      <h6>Полностью онлайн для 5&ndash;8 и&nbsp;10&nbsp;классов:</h6>
      <p>
        Для учеников (на&nbsp;любой форме обучения) 5&ndash;8 и&nbsp;10&nbsp;классов аттестация
        проходит онлайн. Аттестация в&nbsp;5&ndash;8 и&nbsp;10&nbsp;классах&nbsp;&mdash; это
        годовые контрольные работы по&nbsp;всем школьным предметам, которые проходят в&nbsp;
        онлайн-формате с&nbsp;включенными камерами и&nbsp;микрофонами под контролем учителя.
      </p>
      <h6>Очно для 9&nbsp;и&nbsp;11&nbsp;классов:</h6>
      <p>
        Для выпускных 9&nbsp;и&nbsp;11&nbsp;классов аттестация проходит в&nbsp;виде
        государственных экзаменов (ОГЭ и&nbsp;ЕГЭ). Ученикам нашей школы, которые обучаются
        на&nbsp;заочной форме,  необходимо будет приехать на&nbsp;экзамены в&nbsp;Москву.
        Выпускники заочной формы в&nbsp;нашей школе получат московский аттестат гос. образца
        от&nbsp;Университета Синергия.
      </p>

      <p>
        Те, кто обучается у&nbsp;нас на&nbsp;семейной форме с&nbsp;прикреплением, могут выбрать:
        сдавать экзамены от&nbsp;нашей школы или от&nbsp;школы по&nbsp;выбору (часто это школа
        по&nbsp;месту жительства), куда нужно будет прикрепиться на&nbsp;период экзаменов.
        Важно, что при этом выпускник получит аттестат именно той школы, в&nbsp;которой сдавал
        экзамены. Если выпускник сдает экзамены в&nbsp;Москве от&nbsp;нашей школы,
        то&nbsp;получит московский аттестат гос. образца от&nbsp;Университета Синергия,
        если в&nbsp;другой школе, то&nbsp;аттестат той школы.
      </p>
    `,
  },
  {
    title: 'Как проходит обучение?',
    body: `
      <p>
        В&nbsp;зависимости от&nbsp;выбранного тарифа обучения, ребенок может учится
        в&nbsp;мини-группах (связь с&nbsp;учителем через камеру и&nbsp;микрофон, максимальное
        внимание вашему ребенку) или на&nbsp;вебинрах (связь с&nbsp;учителем через чат),
        смотреть уроки можно в&nbsp;записи, во&nbsp;время и&nbsp;после урока ученику доступна
        интерактивная платформа с&nbsp;тренажерами, конспектами и&nbsp;домашними заданиями.
      </p>
      <p>
        С&nbsp;каждым учеником работает целая команда заботы: классный руководитель поможет
        адаптироваться в&nbsp;школе и&nbsp;классе, с&nbsp;радостью решит любые организационные
        вопросы; наставник подскажет по&nbsp;предметным вопросам и&nbsp;поможет
        с&nbsp;домашками; также в&nbsp;нашей школе работают тьютор,
        психолог и&nbsp;профориентолог.
      </p>
    `,
  },
];

export const tutors = [
  {
    title: 'Что будет на пробном уроке?',
    body: `
      <p>
        Пробное занятие длится 30 минут и состоит из: <br>
        — диагностики знаний;<br>
        — проверки психологической совместимости ученика-учителя.
      </p>
      <p class="mt-1em">
        После вводного урока мы даём детальный комментарий, в него входят: <br>
        — оценка психологического комфорта ученика;<br>
        — помощь в постановке чёткой цели;<br>
        — оценка текущего уровня знаний;<br>
        — рекомендуемое кол-во занятий для достижения результата
      </p>
    `,
  },
  {
    title: 'По каким предметам есть репетиторы?',
    body: `
      <p>
        Наши репетиторы готовят учеников по&nbsp;всем школьным предметам
        с&nbsp;1&nbsp;по&nbsp;11&nbsp;класс и&nbsp;к&nbsp;экзаменам ОГЭ/ЕГЭ.
         Мы&nbsp;также можем подобрать репетитора индивидуально под ваш запрос
      </p>
    `,
  },
  {
    title: 'Как проходит занятие?',
    body: `
      <p>
        Учитель и&nbsp;ученик на&nbsp;занятии проходят все необходимые этапы урока: <br>
        1. Проверка домашнего задания и&nbsp;анализ ошибок <br>
        2. Повторение пройденного материала <br>
        3. Разбор теории по&nbsp;теме урока <br>
        4. Практические задания <br>
        5. Рефлексия по&nbsp;результатам занятия
      </p>
    `,
  },
  {
    title: 'Что делать, если придется пропустить урок?',
    body: `
      <p>
        Урок можно перенести, если вы&nbsp;предупредите куратора о&nbsp;переносе за&nbsp;5&nbsp;часов до&nbsp;урока.
        Если вы&nbsp;сообщите об&nbsp;отмене урока менее чем за&nbsp;5&nbsp;часов до&nbsp;него, занятие сгорает
      </p>
    `,
  },
  {
    title: 'Где проходят уроки?',
    body: `
      <p>
        Уроки проходят на&nbsp;платформе ZOOM. Для него нужны: <br>
        1.Компьютер/ноутбук, камера, микрофон <br>
        2.Канцелярия: тетрадка и&nbsp;ручка, карандаш (как удобно ученику)
      </p>
    `,
  },
  {
    title: 'Готовите ли вы к экзаменам?',
    body: `
      <p>
        Да, в&nbsp;нашей базе репетиторов есть сертифицированные эксперты ЕГЭ и&nbsp;ОГЭ, которые знают все
        тонкости и&nbsp;подводные камни экзаменов. Также мы&nbsp;готовим учеников к&nbsp;школьным
        аттестациям и&nbsp;ВПР
      </p>
    `,
  },
  {
    title: 'Сколько длится занятие?',
    body: `
      <p>
        Стандартное занятие длится 40&nbsp;минут&nbsp;&mdash; это оптимальное время, в&nbsp;течение
        которого ученик может максимально эффективно усваивать информацию
      </p>
    `,
  },
  {
    title: 'Есть ли домашние задания?',
    body: `
      <p>
        Да. Как показывают современные педагогические исследования, домашние задания позволяют добиться
        максимальной эффективности обучения. Формат и&nbsp;объем д/з корректируется исходя
        из&nbsp;потребностей конкретного ученика
      </p>
    `,
  },
  {
    title: 'Кто проводит пробный урок?',
    body: `
      <p>
        Вводный урок проводит преподаватель, которого мы&nbsp;подберём для вас индивидуально.
        Этот&nbsp;же учитель будет вести занятия у&nbsp;вашего ребёнка в&nbsp;дальнейшем,
        если вы&nbsp;примите решение продолжать обучение с&nbsp;нами
      </p>
    `,
  },
];

export const oge = [
  {
    title: 'В какое время и сколько раз в неделю проходят занятия?',
    body: `
      <p>
        Интенсив длится три недели прямо перед экзаменом в&nbsp;общей сумме 6&nbsp;занятий
        по&nbsp;каждому предмету. Длятся они по&nbsp;90&nbsp;минут,
        с&nbsp;16&nbsp;до&nbsp;21&nbsp;часа по&nbsp;будням
        и&nbsp;с&nbsp;10&nbsp;до&nbsp;21&nbsp;часа по&nbsp;выходным дням
      </p>
    `,
  },
  {
    title: 'Сможет ли ученик к кому-то обратиться, если остались вопросы после урока?',
    body: `
      <p>
        С&nbsp;учеником на&nbsp;связи сразу несколько специалистов: куратор
        и&nbsp;наставники. Куратор оказывает психологическую поддержку и&nbsp;следит
        за&nbsp;выполнением&nbsp;дз, посещением уроков. Наставники объясняют теорию,
        если на&nbsp;уроке было не&nbsp;понятно, проверяют домашние задания и&nbsp;следят прогрессом
      </p>
    `,
  },
  // {
  //   title: 'Почему нет ОГЭ по географии?',
  //   body: `
  //     <p>
  //       Темы кодификатора по&nbsp;географии помещаются в&nbsp;курс неравномерно относительно
  //       других предметов, предмет для подготовки в&nbsp;формате курсов выбирают очень маленькое
  //       количество людей и&nbsp;поэтому в&nbsp;этом году мы&nbsp;предлагаем репетитора при необходимости
  //     </p>
  //   `,
  // },
  {
    title: 'Как родитель может отслеживать темы занятий и успеваемость ученика в процессе подготовки?',
    body: `
      <p>
        Темы занятий и&nbsp;результаты ученика доступны на&nbsp;платформе.
        Можно отдельно запросить обратную связь об&nbsp;успехах у&nbsp;куратора курсов
      </p>
    `,
  },
  {
    title: 'Нужно ли дополнительно приобретать учебные пособия?',
    body: `
      <p>
        Это не&nbsp;обязательно. В&nbsp;рамках каждого курса предлагается исчерпывающее
        количество материалов для подготовки на&nbsp;платформе
      </p>
    `,
  },
  {
    title: 'Можно ли добавить/поменять предмет в середине обучения?',
    body: `
      <p>
        Можно переподключиться на&nbsp;тот предмет, который вам будет нужен, все записи уроков будут доступны
      </p>
    `,
  },
  {
    title: 'Как вы подбираете преподавателей?',
    body: `
      <p>
        Мы&nbsp;внимательно выбираем преподавателей со&nbsp;значительным опытом в&nbsp;подготовке
        к&nbsp;ОГЭ и&nbsp;ЕГЭ. Они проходят три этапа отбора и&nbsp;только
        1&nbsp;из&nbsp;7&nbsp;приходит к&nbsp;нам
      </p>
    `,
  },
  {
    title: 'Есть ли дополнительные платежи в процессе обучения?',
    body: `
      <p>Нет</p>
    `,
  },
  {
    title: 'Можно ли оплатить обучение в рассрочку?',
    body: `
      <p>
        Да, вы&nbsp;можете разбить обучение в&nbsp;рассрочку и&nbsp;платить
        1&nbsp;раз в&nbsp;месяц в&nbsp;течение 6&nbsp;или 12&nbsp;месяцев
      </p>
    `,
  },
  {
    title: 'Я не могу посещать онлайн, что делать?',
    body: `
      <p>
        На&nbsp;нашей платформе все занятия выгружаются онлайн: если пропустили
        или хотите пересмотреть&nbsp;&mdash; все они доступны в&nbsp;записи
      </p>
    `,
  },
];

export const ege = [
  {
    title: 'В&nbsp;какое время и&nbsp;сколько раз в&nbsp;неделю проходят занятия?',
    body: `
      <p>
        Занятия по&nbsp;каждому предмету проходят 2&nbsp;раза в&nbsp;неделю и&nbsp;длятся
        90&nbsp;минут, с&nbsp;16&nbsp;до&nbsp;21&nbsp;часа по&nbsp;будням
        и&nbsp;с&nbsp;10&nbsp;до&nbsp;21&nbsp;часа по&nbsp;выходным дням
      </p>
    `,
  },
  {
    title: 'Успеем ли мы подготовиться к ЕГЭ?',
    body: `
      <p>
        Каждый блок тем соответствует блоку тем кодификатора, программа устроена так,
        что ни одна тема не будет пропущена
      </p>
    `,
  },
  {
    title: 'Гарантируете ли вы поступление в вуз?',
    body: `
      <p>
        Так как мы&nbsp;часть большого университета Синергия мы&nbsp;гарантируем
        скидку&nbsp;30% на&nbsp;обучение в&nbsp;нашем университете, а&nbsp;также
        высокие результаты подготовки, при условии посещения всех уроков, выполнения
        домашних заданий и&nbsp;следованию обратной связи наставников
      </p>
    `,
  },
  {
    title: 'Как проверить свои знания?',
    body: `
      <p>
        К&nbsp;каждому уроку дается домашнее задание на&nbsp;отработку первой части
        и&nbsp;каждую неделю письменное на&nbsp;отработку второй, так все темы
        и&nbsp;задания отрабатываются максимально тщательно
      </p>
    `,
  },
  {
    title: 'Нужно&nbsp;ли дополнительно приобретать учебные пособия?',
    body: `
      <p>
        Это не&nbsp;обязательно. В&nbsp;рамках каждого курса предлагается исчерпывающее
        количество материалов для подготовки на&nbsp;платформе
      </p>
    `,
  },
  {
    title: 'Можно&nbsp;ли добавить/поменять предмет в&nbsp;середине обучения?',
    body: `
      <p>
        Можно переподключиться на&nbsp;тот предмет, который вам будет нужен,
        все записи уроков будут доступны
      </p>
    `,
  },
  {
    title: 'Как вы&nbsp;подбираете преподавателей?',
    body: `
      <p>
        Мы&nbsp;внимательно выбираем преподавателей со&nbsp;значительным опытом
        в&nbsp;подготовке к&nbsp;ОГЭ и&nbsp;ЕГЭ. Они проходят три этапа отбора
        и&nbsp;только 1&nbsp;из&nbsp;7&nbsp;приходит к&nbsp;нам
      </p>
    `,
  },
  {
    title: 'Есть&nbsp;ли дополнительные платежи в&nbsp;процессе обучения?',
    body: `
      <p>Нет</p>
    `,
  },
  {
    title: 'Можно&nbsp;ли оплатить обучение в&nbsp;рассрочку?',
    body: `
      <p>
        Да, вы&nbsp;можете разбить обучение в&nbsp;рассрочку и&nbsp;платить 1&nbsp;раз
        в&nbsp;месяц в&nbsp;течение 6&nbsp;или 12&nbsp;месяцев
      </p>
    `,
  },
  {
    title: 'Я не могу посещать онлайн, что делать?',
    body: `
      <p>
        На&nbsp;нашей платформе все занятия выгружаются онлайн: если пропустили или
        хотите пересмотреть&nbsp;&mdash; все они доступны в&nbsp;записи
      </p>
    `,
  },
];

export const external = [
  {
    title: 'Какие документы необходимо предоставить по&nbsp;программе экстернат?',
    body: `
      <p>
        Базовый комплект документов включает в&nbsp;себя сканы паспорта обучающегося и&nbsp;родителя,
        СНИЛС, выписку из&nbsp;личной карты с&nbsp;оценками за&nbsp;предыдущие классы или скан аттестата
        для обучающихся 10-11&nbsp;классов. Также нужно будет подписать согласие на&nbsp;обработку
        персональных данных и&nbsp;заявление на&nbsp;аттестацию
      </p>
    `,
  },
  {
    title: 'Как проходят аттестации?',
    body: `
      <p>
        Аттестации по&nbsp;всем предметам проходят по&nbsp;установленному графику. На&nbsp;аттестацию
        не&nbsp;потребуется приезжать в&nbsp;школу, т.к. все пройдет в&nbsp;онлайн-формате.
        Важно: на&nbsp;онлайн-аттестацию нужно подключиться с&nbsp;камерой, в&nbsp;течение 40&nbsp;минут
        выполнить аттестационную работу и&nbsp;отправить ее&nbsp;на&nbsp;проверку
      </p>
    `,
  },
  {
    title: 'Что будет, если я&nbsp;не&nbsp;сдам аттестацию, хотя&nbsp;бы по&nbsp;одному предмету?',
    body: `
      <p>
        В&nbsp;случае неудовлетворительного результата аттестации по&nbsp;какому-либо
        предмету обучающемуся будет предоставлена возможность пересдачи в&nbsp;доп. сроки
      </p>
    `,
  },
  {
    title: 'В какой школе мне сдавать ОГЭ/ЕГЭ?',
    body: `
      <p>
        Выпускные очные экзамены можно сдать в&nbsp;школе в&nbsp;своем регионе
        (при условии заблаговременного прикрепления к&nbsp;такой школе), либо сдать
        в&nbsp;образовательных учреждениях Москвы, куда вы&nbsp;будете направлены
        от&nbsp;школы &laquo;Синергия&raquo;
      </p>
    `,
  },
  {
    title: 'Как сдавать итоговое собеседование/сочинение?',
    body: `
      <p>
        Как и&nbsp;в&nbsp;случае со&nbsp;сдачей ОГЭ/ЕГЭ существует два варианта: можно сдать итоговое
        сочинение/итоговое собеседование в&nbsp;школе в&nbsp;своем регионе, либо зарегистрироваться
        на&nbsp;сдачу этих экзаменов от&nbsp;школы &laquo;Синергия&raquo; в&nbsp;Москве
      </p>
    `,
  },
  {
    title: `
      К&nbsp;кому мне можно обратиться, если что-то&nbsp;в&nbsp;организационном
      процессе будет непонятно?
    `,
    body: `
      <p>
        На&nbsp;протяжении всего обучения в&nbsp;онлайн-школе вас будет сопровождать персональный
        куратор, который поможет разобраться со&nbsp;всеми вопросами
      </p>
    `,
  },
];

export const softSkills = [
  {
    title: 'Зачем моему ребенку курс, если у&nbsp;него и&nbsp;так все в&nbsp;порядке?',
    body: `
      <p>
        Большинство людей по&nbsp;умолчанию обладает гибкими навыками на&nbsp;&laquo;бытовом&raquo;
        уровне, но&nbsp;в&nbsp;будущем этого может быть недостаточно. С&nbsp;повсеместным
        использованием&nbsp;ИИ и&nbsp;нейросетей, способных работать с&nbsp;большим объемом информации и&nbsp;выполнять
        сложные задачи за&nbsp;несколько секунд, многие профессии оказались под угрозой исчезновения. В&nbsp;грядущем
        мире именно профессионально развитые гибкие навыки (коммуникация, креативность и&nbsp;работа с&nbsp;эмоциями)
        помогут ребенку адаптироваться и&nbsp;стать незаменимым специалистом
      </p>
    `,
  },
  {
    title: 'Как проходят занятия?',
    body: `
      <p>
        Уроки проходят в&nbsp;формате живых созвонов с&nbsp;учителем (с&nbsp;камерой и&nbsp;микрофоном). Дети напрямую
        общаются с&nbsp;экспертом, выполняют индивидуальные и&nbsp;командные упражнения. Материал урока и&nbsp;задания
        отрабатываются на&nbsp;нашей интерактивной платформе и&nbsp;доступны в&nbsp;течение всего обучения. Благодаря
        игровому формату дети легко усваивают информацию и&nbsp;с&nbsp;нетерпением ждут следующего урока
      </p>
    `,
  },
  {
    title: 'Что делать, если мы&nbsp;пропустили урок?',
    body: `
      <p>
        Если вы&nbsp;не&nbsp;можете присутствовать на&nbsp;занятии, предупредите куратора за&nbsp;24&nbsp;часа
        до&nbsp;его начала: он&nbsp;расскажет, как вы&nbsp;можете пройти материал самостоятельно. Затем вы&nbsp;можете
        посмотреть урок в&nbsp;записи и&nbsp;возвращаться к&nbsp;нему в&nbsp;течение всего курса
      </p>
    `,
  },
  {
    title: 'Как ребенок отрабатывает материал курса?',
    body: `
      <p>
        Мы&nbsp;не&nbsp;хотим перенагружать детей, но&nbsp;практическая отработка навыков очень важна. Поэтому
        мы&nbsp;продумали систему увлекательных заданий&nbsp;&mdash; практик и&nbsp;экспериментов. Их&nbsp;выполнять
        легко и&nbsp;интересно, но&nbsp;необязательно&nbsp;&mdash; можно пройти курс и&nbsp;без них
      </p>
    `,
  },
  {
    title: 'Почему в группе 5–7 человек?',
    body: `
      <p>
        Мы&nbsp;подобрали оптимальное количество участников, чтобы детям было уделено достаточно внимания, но&nbsp;при
        этом оставалась групповая работа. Гибкие навыки формируются только при взаимодействии с&nbsp;командой
      </p>
    `,
  },
  {
    title: 'Нужно&nbsp;ли участие родителя в&nbsp;курсе?',
    body: `
      <p>
        Присутствие родителя на&nbsp;уроке не&nbsp;требуется, но&nbsp;ребенку важна ваша поддержка и&nbsp;внимание
        в&nbsp;течение курса. Также мы&nbsp;будем высылать родителю персональный отчет после каждого модуля, где
        вы&nbsp;сможете узнать сильные стороны, точки роста и&nbsp;рекомендации по&nbsp;развитию от&nbsp;эксперта.
        Мы&nbsp;рекомендуем обсуждать их&nbsp;с&nbsp;ребенком, рефлексировать и&nbsp;планомерно внедрять
      </p>
    `,
  },
  {
    title: 'Насколько эффективно онлайн-обучение?',
    body: `
      <p>
        Материал урока наглядно представлен и&nbsp;адаптирован, а&nbsp;наши специалисты специально обучены работе
        в&nbsp;онлайн-формате с&nbsp;детьми. Мы&nbsp;используем все преимущества онлайн среды, разработанные
        российскими и&nbsp;зарубежными педагогоми: геймификация, маинд-карты, интерактивные инструменты для
        групповой работы, боты и&nbsp;т.д.
      </p>
    `,
  },
  {
    title: 'Когда можно присоединиться к&nbsp;курсу?',
    body: `
      <p>
        Мы&nbsp;регулярно набираем группы, поэтому оставьте заявку и&nbsp;мы&nbsp;свяжемся
        с&nbsp;вами для уточнения расписания
      </p>
    `,
  },
];

export const finalEssay = [
  {
    title: 'Как сформулировать проблему для выбранной темы?',
    body: `
      <p>
        Перепишите тему в&nbsp;свой черновик и&nbsp;подчеркните ключевые слова.
        Именно они подскажут, о&nbsp;чем будет сочинение
      </p>
    `,
  },
  {
    title: 'Какие советы помогут сделать итоговое сочинение более глубоким, аналитическим и&nbsp;выразительным?',
    body: `
      <ul>
        <li>Используйте только те&nbsp;слова, в&nbsp;которых уверены и&nbsp;понимаете их&nbsp;значение.</li>
        <li>Соблюдайте ритм текста: одно короткое предложение&nbsp;&mdash; одно длинное.</li>
        <li>Используйте те&nbsp;аргументы, в&nbsp;которых вы&nbsp;уверены: не&nbsp;нужно писать много примеров.</li>
        <li>Не&nbsp;забывайте про эпитеты, сравнения, фразеологизмы и&nbsp;другие средства выразительности</li>
      </ul>
    `,
  },
  {
    title: 'Каким дополнительным материалом можно пользоваться при написании итогового сочинения?',
    body: `
      <p>
        Разрешается пользоваться орфографическими словарями, выданными Комиссией по&nbsp;проведению итогового сочинения
      </p>
    `,
  },
  {
    title: 'Будут&nbsp;ли темы итогового сочинения сформулированы только в&nbsp;виде вопроса?',
    body: `
      <p>
        Темы итогового сочинения могут быть сформулированы как в&nbsp;виде вопроса,
        так и&nbsp;в&nbsp;виде цитаты или утверждения
      </p>
    `,
  },
  {
    title: 'В&nbsp;каких случаях за&nbsp;сочинение может быть выставлен &laquo;зачет&raquo;?',
    body: `
      <p>
        Для получения &laquo;зачета&raquo; необходимо иметь положительный результат
        по&nbsp;3&nbsp;критериям (по&nbsp;критериям &#8470;&nbsp;1&nbsp;(соответствие теме)
        и &#8470;&nbsp;2&nbsp;(аргументация, привлечение литературного материала)&nbsp;&mdash;
        в&nbsp;обязательном порядке); выдержать объем (сочинение не&nbsp;менее 250&nbsp;слов)
        и&nbsp;написать работу самостоятельно
      </p>
    `,
  },
  {
    title: 'В&nbsp;каком жанре нужно писать итоговое сочинение?',
    body: `
      <p>Сочинение-рассуждение</p>
    `,
  },
];

export const finalInterview = [
  {
    title: 'Что такое устное собеседование?',
    body: `
      <p>
        Это допуск к&nbsp;ОГЭ. Собеседование проверяет коммуникативные навыки выпускников 9&nbsp;классов: чтение текста
        вслух, пересказ текста с&nbsp;цитатой, способность к&nbsp;монологу и&nbsp;диалогу
      </p>
    `,
  },
  {
    title: 'Сколько баллов нужно набрать на&nbsp;итоговом собеседовании?',
    body: `
      <p>
        Для успешной сдачи итогового собеседования необходимо набрать минимум 10&nbsp;баллов из&nbsp;20
      </p>
    `,
  },
  {
    title: 'Когда будет итоговое собеседование?',
    body: `
      <p>
        Итоговое собеседования пройдет 14&nbsp;февраля 2024 года
      </p>
    `,
  },
  {
    title: 'Есть&nbsp;ли резервные дни по&nbsp;итоговому собеседованию?',
    body: `
      <p>
        В&nbsp;2024 году резервные дни по&nbsp;итоговому собеседованию: 13&nbsp;марта и&nbsp;6&nbsp;мая 2024 года
      </p>
    `,
  },
  {
    title: 'Когда будут известны результаты по&nbsp;итоговому собеседованию?',
    body: `
      <p>
        Результат &laquo;зачет&raquo; или &laquo;незачет&raquo; все участники экзамена узнают не&nbsp;позднее чем
        через 5&nbsp;календарных дней с&nbsp;даты проведения итогового собеседования
      </p>
    `,
  },
];

export const repetitor = [
  {
    title: 'Что такое пробный урок?',
    body: `
      <p>
        Пробный урок – это бесплатное занятие, которое длится 30 минут и состоит из:
        <br>
        <br>
        — диагностики знаний;
        <br>
        — проверки психологической совместимости ученика-учителя.
        <br>
        <br>
        После вводного урока мы даём детальный комментарий, в него входят:
        <br>
        <br>
        — оценка психологического комфорта ученика;
        <br>
        — помощь в постановке чёткой цели;
        <br>
        — оценка текущего уровня знаний;
        <br>
        — рекомендуемое кол-во занятий для достижения результата
      </p>
    `,
  },
  {
    title: 'Можно ли увидеть запись занятия с репетитором?',
    body: `
      <p>
        Да, после прохождения занятий вам будут доступны видеозаписи
      </p>
    `,
  },
  {
    title: 'По каким предметам есть репетиторы?',
    body: `
      <p>
        Наши репетиторы готовят учеников по&nbsp;всем школьным предметам с&nbsp;1&nbsp;по&nbsp;11&nbsp;класс и&nbsp;к&nbsp;экзаменам ОГЭ/ЕГЭ. Мы&nbsp;также можем подобрать репетитора индивидуально под ваш запрос
      </p>
    `,
  },
  {
    title: 'Как проходит занятие?',
    body: `
      <p>
        Учитель и ученик на занятии проходят все необходимые этапы урока:
        <br>
        <br>
        1. Проверка домашнего задания и анализ ошибок
        <br>
        2. Повторение пройденного материала
        <br>
        3. Разбор теории по теме урока
        <br>
        4. Практические задания
        <br>
        5. Рефлексия по результатам занятия
      </p>
    `,
  },
  {
    title: 'Что делать, если придется пропустить урок?',
    body: `
      <p>
        Урок можно перенести, если вы&nbsp;предупредите куратора о&nbsp;переносе за&nbsp;5&nbsp;часов до&nbsp;урока. Если вы&nbsp;сообщите об&nbsp;отмене урока менее чем за&nbsp;5&nbsp;часов до&nbsp;него, занятие сгорает
      </p>
    `,
  },
  {
    title: 'На какой платформе проходят уроки?',
    body: `
      <p>
        Уроки проходят на платформе ZOOM. Для него нужны:
        <br>
        <br>
        Компьютер/ноутбук, камера, микрофон
        <br>
        Канцелярия: тетрадка и ручка, карандаш (как удобно ученику)
      </p>
    `,
  },
  {
    title: 'Готовите ли вы к экзаменам?',
    body: `
      <p>
        Да, в&nbsp;нашей базе репетиторов есть сертифицированные эксперты ЕГЭ и&nbsp;ОГЭ, которые знают все тонкости и&nbsp;подводные камни экзаменов. Также мы&nbsp;готовим учеников к&nbsp;школьным аттестациям и&nbsp;ВПР
      </p>
    `,
  },
  {
    title: 'Сколько длится занятие?',
    body: `
      <p>
        Стандартное занятие длится 40&nbsp;минут&nbsp;&mdash; это оптимальное время, в&nbsp;течение которого ученик может максимально эффективно усваивать информацию
      </p>
    `,
  },
  {
    title: 'Есть ли домашние задания?',
    body: `
      <p>
        Да. Как показывают современные педагогические исследования, домашние задания позволяют добиться максимальной эффективности обучения. Формат и&nbsp;объем д/з корректируется исходя из&nbsp;потребностей конкретного ученика
      </p>
    `,
  },
  {
    title: 'Кто проводит пробный урок?',
    body: `
      <p>
        Вводный урок проводит преподаватель, которого мы&nbsp;подберём для вас индивидуально. Этот&nbsp;же учитель будет вести занятия у&nbsp;вашего ребёнка в&nbsp;дальнейшем, если вы&nbsp;примите решение продолжать обучение с&nbsp;нами
      </p>
    `,
  },
  {
    title: 'Можно ли поменять репетитора в процессе занятий?',
    body: `
      <p>
        Да, конечно, вы можете поменять репетитора
      </p>
    `,
  },
  {
    title: 'Ведет ли репетитор мониторинг освоения материала у ребенка? ',
    body: `
      <p>
        Да, репетитор отслеживает освоение знаний и&nbsp;успеваемость ученика. Результаты обучения доступны на&nbsp;платформе. Вы&nbsp;можете также отдельно запросить обратную связь об&nbsp;успехах у&nbsp;куратора занятий
      </p>
    `,
  },
  {
    title: 'В каких часовых поясах вы работаете?',
    body: `
      <p>
        Мы работаем во всех часовых поясах.
      </p>
    `,
  },
];

export const programmirovanie = [
  {
    title: 'Нужен&nbsp;ли ребенку опыт в&nbsp;программировании, чтоб начать учиться?',
    body: `
      <p>
        Нет, опыт не&nbsp;обязателен, т.&nbsp;к.&nbsp;у&nbsp;нас много программ, которые рассчитаны на&nbsp;то, чтобы обучить ребенка с&nbsp;нуля. Если&nbsp;же ребенок начнет учебу, уже имея некоторые знания и&nbsp;навыки, то&nbsp;это безусловно большой плюс, и&nbsp;мы, со&nbsp;своей стороны, поможем ему их&nbsp;расширить и&nbsp;углубить.
      </p>
    `,
  },
  {
    title: 'Что нужно для обучения, какая техника? ',
    body: `
      <p>
        Видеоуроки и&nbsp;вебинары можно смотреть с&nbsp;любого устройства: смартфон, планшет, ноутбук или компьютер. Для выполнения домашних заданий в&nbsp;некоторых курсах понадобятся и&nbsp;смартфон, и&nbsp;компьютер, а&nbsp;определенные задания можно выполнить только на&nbsp;компьютере. По&nbsp;конкретным программам <br> и&nbsp;техническим характеристикам устройства (операционная система, браузер, оперативная память и&nbsp;др.) вас сориентируют наши кураторы и&nbsp;преподаватели
      </p>
    `,
  },
  {
    title: 'Насколько удобно дистанционное обучение?',
    body: `
      <p>
        Это удобно: ребенок может заниматься из&nbsp;любой локации в&nbsp;комфортной для себя обстановке. Все, что потребуется&nbsp;&mdash; доступ к&nbsp;интернету для занятия в&nbsp;режиме реального времени. А&nbsp;видеоуроки всегда доступны в&nbsp;личном кабинете на&nbsp;платформе Synergy LMS.
      </p>
    `,
  },
  {
    title: 'Что делать, если ребенок пропустил занятие?',
    body: `
      <p>
        Ничего страшного, прошедший урок ребенок сможет просмотреть в&nbsp;видеозаписи, которая будет вам доступна после занятия. Видеоуроки можно смотреть и&nbsp;пересматривать несколько раз в&nbsp;любое время. Теорию, материалы и&nbsp;домашнее задание по&nbsp;каждому уроку вы&nbsp;найдете на&nbsp;платформе, а&nbsp;по&nbsp;всем вопросам сможете связаться с&nbsp;куратором в&nbsp;чате.
      </p>
    `,
  },
  {
    title: 'Кем станет ребенок в будущем?',
    body: `
      <p>
        Программы наших курсов дают детям не&nbsp;только понимание области, в&nbsp;которую они погрузились, но&nbsp;необходимые навыки, чтобы начать создавать свои проекты и&nbsp;развиваться дальше в&nbsp;таких востребованных IT-профессиях, как: разработчик, программист игр, frontend-специалист, геймдизайнер и&nbsp;другие специальности.
      </p>
    `,
  },
  {
    title: 'Как выбрать программу, если не разбираюсь в IT?',
    body: `
      <p>
        Оставьте заявку на&nbsp;обучение, выбрав ту&nbsp;программу, которая вас заинтересовала. Вам придет письмо с&nbsp;первым уроком, в&nbsp;котором вы&nbsp;можете познакомиться с&nbsp;программой обучения, узнать ее&nbsp;особенности <br> и&nbsp;понять, чем она отличается от&nbsp;других курсов. Это бесплатно и&nbsp;ни&nbsp;к&nbsp;чему не&nbsp;обязывает. Также с&nbsp;вами свяжется наш менеджер, который сориентирует вас по&nbsp;нашим курсам и&nbsp;поможет определиться, какую программу выбрать.
      </p>
    `,
  },
];

export const externalAdult = [
  {
    title: 'Как происходит зачисление?',
    body: `
      <p>
        1. Оплачиваете обучение <br>
        2. Предоставляете необходимые документы <br>
        3. Получаете приветственное сообщение от персонального куратора о зачислении
      </p>
    `,
  },
  {
    title: 'Какие документы необходимо предоставить по программе экстернат?',
    body: `
      <p>
        Базовый комплект документов включает в&nbsp;себя сканы паспорта обучающегося, СНИЛС, выписку из&nbsp;личной карты с&nbsp;оценками за&nbsp;предыдущие классы или скан аттестата для обучающихся 10-11&nbsp;классов. Также нужно будет подписать согласие на&nbsp;обработку персональных данных и&nbsp;заявление на&nbsp;аттестацию.
      </p>
    `,
  },
  {
    title: 'Как совмещать экстернат с работой/учебой?',
    body: `
      <p>
        У&nbsp;нас есть все необходимые обучающие материалы, к&nbsp;которым вы&nbsp;можете обращаться через платформу в&nbsp;любое удобное для вас время. В&nbsp;зависимости от&nbsp;выбранного тарифа вам могут быть доступны обучающие вебинары: они проходят во&nbsp;второй половине дня по&nbsp;московскому времени. В&nbsp;случае, если вы&nbsp;не&nbsp;смогли подключиться к&nbsp;вебинару онлайн, он&nbsp;будет доступен вам в&nbsp;записи.
      </p>
    `,
  },
  {
    title: 'Как и когда проходят аттестации?',
    body: `
      <p>
        На&nbsp;тарифе Экстернат с&nbsp;подготовкой аттестации по&nbsp;всем предметам проходят по&nbsp;установленному графику. На&nbsp;аттестацию не&nbsp;потребуется приезжать в&nbsp;школу, т.к. все пройдет в&nbsp;онлайн-формате (кроме экзаменов ОГЭ/ЕГЭ). На&nbsp;тарифе Экстернат без подготовки аттестации проходят также в&nbsp;онлайн-формате в&nbsp;любое удобное для вас время в&nbsp;течение учебного года. Единое для всех расписание ОГЭ/ЕГЭ и&nbsp;продолжительность экзаменов по&nbsp;каждому образовательному предмету ежегодно устанавливает соответствующий приказ Министерства просвещения Российской Федерации.
      </p>
    `,
  },
  {
    title: 'Что будет если я не сдам аттестацию хотя бы по одному предмету?',
    body: `
      <p>
        В случае неудовлетворительного результата аттестации по какому-либо предмету обучающемуся будет предоставлена возможность пересдачи в доп. сроки.
      </p>
    `,
  },
  {
    title: 'В какой школе мне сдавать ОГЭ/ЕГЭ, итоговое собеседование и итоговое сочинение?',
    body: `
      <p>
        Можно сдать в&nbsp;школе в&nbsp;своем регионе (при условии заблаговременного прикрепления к&nbsp;такой школе), либо сдать в&nbsp;образовательных учреждениях Москвы, куда вы&nbsp;будете направлены от&nbsp;школы &laquo;Синергия&raquo;.
      </p>
    `,
  },
  {
    title: 'К кому мне можно обратиться, если что-то в организационном процессе будет непонятно?',
    body: `
      <p>
        На&nbsp;протяжении всего обучения в&nbsp;онлайн-школе вас будет сопровождать персональный куратор, который поможет разобраться со&nbsp;всеми вопросами.
      </p>
    `,
  },
  {
    title: 'Сколько времени необходимо тратить на обучение в день?',
    body: `
      <p>
        Зависит от&nbsp;того, как быстро вы&nbsp;планируете закрыть аттестацию, минимально мы&nbsp;рекомендуем посвящать учебе от&nbsp;1-2 часов ежедневно.
      </p>
    `,
  },
  {
    title: 'Какой экстернат лучше выбрать – с подготовкой или без?',
    body: `
      <p>
        Зависит от&nbsp;вашей потребности&nbsp;&mdash; если вы&nbsp;поступаете в&nbsp;вуз, и&nbsp;вам необходима помощь с&nbsp;подготовкой к&nbsp;экзаменам, то&nbsp;лучше выбрать тариф Экстернат с&nbsp;подготовкой, где опытные преподаватели и&nbsp;наставники пройдут вместе с&nbsp;вами путь от&nbsp;старта обучения до&nbsp;начала итоговой аттестации. Если вы&nbsp;уверены в&nbsp;своих знаниях и&nbsp;уровне самодисциплины&nbsp;&mdash; тариф Экстернат без подготовки для вас. <button class="m-btn">Оставьте заявку,</button> чтобы получить более подробную информацию по&nbsp;доступным программам обучения.
      </p>
    `,
  },
];

export const externalNew = [
  {
    title: 'Как происходит зачисление?',
    body: `
      <p>
        1. Оплачиваете обучение <br>
        2. Предоставляете необходимые документы <br>
        3. Получаете приветственное сообщение от персонального куратора о зачислении
      </p>
    `,
  },
  {
    title: 'Какие документы необходимо предоставить по программе экстернат?',
    body: `
      <p>
        Базовый комплект документов включает в себя сканы свидетельства о рождении или паспорта обучающегося, скан паспорта родителя, СНИЛС обучающегося, выписку из личной карты с оценками за предыдущие классы или скан аттестата для обучающихся 10-11 классов. Также нужно будет подписать согласие на обработку персональных данных и заявление на аттестацию.
      </p>
    `,
  },
  {
    title: 'Как и когда проходят аттестации?',
    body: `
      <p>
        На тарифе Экстернат с подготовкой аттестации по всем предметам проходят по установленному графику. На аттестацию не потребуется приезжать в школу, т.к. все пройдет в онлайн-формате (кроме экзаменов ОГЭ/ЕГЭ). На тарифе Экстернат без подготовки аттестации проходят также в онлайн-формате в любое удобное для вас время в течение учебного года. Единое для всех расписание ОГЭ/ЕГЭ и продолжительность экзаменов по каждому образовательному предмету ежегодно устанавливает соответствующий приказ Министерства просвещения Российской Федерации.
      </p>
    `,
  },
  {
    title: 'Что будет если ученик не сдаст аттестацию хотя бы по одному предмету?',
    body: `
      <p>
        В случае неудовлетворительного результата аттестации по какому-либо предмету обучающемуся будет предоставлена возможность пересдачи в доп. сроки.
      </p>
    `,
  },
  {
    title: 'В какой школе сдавать ОГЭ/ЕГЭ, итоговое собеседование и итоговое сочинение?',
    body: `
      <p>
        Можно сдать в школе в своём регионе (при условии заблаговременного прикрепления к такой школе), либо сдать в образовательных учреждениях Москвы, куда вы будете направлены от школы «Синергия».
      </p>
    `,
  },
  {
    title: 'К кому мне можно обратиться, если что-то в организационном процессе будет непонятно?',
    body: `
      <p>
        На протяжении всего обучения в онлайн-школе вас будет сопровождать персональный куратор, который поможет разобраться со всеми вопросами.
      </p>
    `,
  },
  {
    title: 'Сколько времени необходимо тратить на обучение в день?',
    body: `
      <p>
        Зависит от того, как быстро вы планируете закрыть аттестацию, минимально мы рекомендуем посвящать учебе от 1-2 часов ежедневно.
      </p>
    `,
  },
  {
    title: 'Какой экстернат лучше выбрать – с подготовкой или без?',
    body: `
      <p>
        Зависит от вашей потребности и уровня самоорганизованности ребенка – если вы планируете поступление в вуз, и вам необходима помощь с подготовкой к экзаменам, то лучше выбрать тариф Экстернат с подготовкой, где опытные преподаватели и наставники пройдут вместе с учеником путь от старта обучения до начала итоговой аттестации. Если вы уверены в знаниях своего ребенка и уровне его самодисциплины (или же готовы самостоятельно подключаться к контролю процесса обучения) –тариф Экстернат без подготовки для вас. Оставьте заявку, чтобы получить более подробную информацию по доступным программам обучения.
      </p>
    `,
  },
  {
    title: 'Эффективно ли онлайн-обучение для детей?',
    body: `
      <p>
        Наш текущий результат — 40% учеников повышают успеваемость в школе, благодаря такому формату. Как это работает? Для обучения по ускоренной программе онлайн потребуется чуть более высокий уровень самоорганизованности, чем для очного обучения в общеобразовательной школе. И это отличное преимущество, потому что вашему ребёнку пригодится такой навык в будущем. Но это не значит, что мы не будем сопровождать ученика в процессе подготовки. У каждого ученика есть персональный куратор, который помогает с организационными вопросами и вопросами аттестаций. Также высококачественная платформа, где вы, как родитель также сможете не только видеть результаты обучения, но и отслеживать прогресс ученика ежедневно / еженедельно / ежемесячно. Наши ученики получают образование в комфортных условиях и в атмосфере заботы: они не мёрзнут в электричках, не мокнут под дождём, не сталкиваются с различными формами психологического насилия. Такой подход помогает им сконцентрироваться на учёбе и не думать о проблемах, с которыми встречаются их сверстники.
      </p>
    `,
  },
];

export const zaochnoe = [
  {
    title: 'Какие документы нужны для поступления?',
    body: `
      <p>
        Базовый пакет документов включает: паспорт родителя и&nbsp;ребенка, свидетельство о&nbsp;рождении
        ребенка, СНИЛС, личная карта обучающегося и&nbsp;аттестат об&nbsp;окончании 9-го класса
        (для поступающих в&nbsp;10&ndash;11&nbsp;класс). Оставьте заявку, и&nbsp;мы&nbsp;подробно расскажем,
        какие документы потребуются и&nbsp;как их&nbsp;собрать.
      </p>
    `,
  },
  {
    title: 'Как проходит обучение?',
    body: `
      <p>
        Обучение проходит в&nbsp;дистанционном формате. Вы&nbsp;получаете доступ к&nbsp;учебным материалам и&nbsp;заданиям, которые необходимо выполнить в&nbsp;установленные сроки. В&nbsp;процессе обучения вы&nbsp;можете консультироваться с&nbsp;преподавателями онлайн или по&nbsp;электронной почте.
      </p>
    `,
  },
  {
    title: 'Какие различия между заочной и семейной формой обучения?',
    body: `
      <p>
        Заочная форма подразумевает, что ребенок зачислен в&nbsp;нашу школу с&nbsp;первого дня обучения, переход к&nbsp;нам на&nbsp;&laquo;заочку&raquo; юридически эквивалентен переходу ребенка в&nbsp;другую классическую школу. В&nbsp;9&nbsp;и&nbsp;11&nbsp;классах ученикам заочной форме необходимо будет приехать на&nbsp;ОГЭ или ЕГЭ в&nbsp;Москву. Наши ученики-заочники получают московский аттестат гос. образца Университета Синергия.
      </p>
      <p>
        Семейная форма обучения подразумевает, что ребенок переведен на&nbsp;семейное обучение и&nbsp;за&nbsp;его обучение отвечает семья. Чтобы не&nbsp;обучать ребенка ежедневно самостоятельно, родители могут перевести ребенка на&nbsp;семейную форму обучения, но&nbsp;доверить его обучение лицензированной удобной онлайн-школе с&nbsp;сильными преподавателями и&nbsp;проверенными материалами по&nbsp;ФГОС.
      </p>
      <p>
        По&nbsp;закону родители могут сами обучать ребенка, но&nbsp;не&nbsp;могут его аттестовать, поэтому на&nbsp;время прохождения аттестации ребенку, который находится на&nbsp;семейном обучении, необходимо прикрепиться к&nbsp;школе: прикрепиться можно к&nbsp;нашей онлайн-школе или к&nbsp;любой другой школе, например, по&nbsp;месту жительства. Выпускник получит аттестат именно той школы, в&nbsp;которой сдавал экзамены.
      </p>
      <p>
        На&nbsp;любой форме обучения в&nbsp;онлайн-школе вы&nbsp;можете посещать занятия, вам открыт доступ ко&nbsp;материалам на&nbsp;платформе, вам также будет доступен весь сервис согласно выбранному тарифу (Премиум, Комфорт или Лайт).
      </p>
    `,
  },
  {
    title: 'Есть ли экзамены и зачеты?',
    body: `
      <p>
        Да, в процессе обучения вам предстоит сдавать экзамены и зачеты в соответствии с требованиями программы.
      </p>
    `,
  },
  {
    title: 'Можно ли совмещать учебу с работой?',
    body: `
      <p>
        Заочное обучение позволяет совмещать учёбу с другими видами деятельности. Это одно из главных преимуществ такого формата.
      </p>
    `,
  },
  {
    title: 'Сколько времени занимает обучение?',
    body: `
      <p>
        Сроки обучения зависят от&nbsp;выбранной программы и&nbsp;интенсивности занятий. Вы&nbsp;можете самостоятельно выбирать темп обучения и&nbsp;определять, сколько времени уделять изучению материала.
      </p>
    `,
  },
  {
    title: 'Какие документы я получу после окончания обучения?',
    body: `
      <p>
        По&nbsp;окончании обучения вы&nbsp;получите документ, подтверждающий ваше образование. Это может быть аттестат или свидетельство о&nbsp;получении дополнительного образования.
      </p>
    `,
  },
  {
    title: 'Могу ли я получить помощь от преподавателей?',
    body: `
      <p>
        Да, вы&nbsp;можете обращаться к&nbsp;преподавателям за&nbsp;помощью и&nbsp;консультациями. Они помогут вам разобраться в&nbsp;сложных темах и&nbsp;ответят на&nbsp;ваши вопросы.
      </p>
    `,
  },
  {
    title: 'Нужно ли мне посещать какие-либо занятия?',
    body: `
      <p>
        Нет, обучение проходит полностью в&nbsp;дистанционном формате. Вам не&nbsp;нужно посещать занятия в&nbsp;классе или аудитории.
      </p>
    `,
  },
];

export const attestacii = [
  {
    title: 'Что означает “прикрепиться к школе”? ',
    body: `
      <p>
        Прикрепиться к&nbsp;школе&nbsp;&mdash; это значит стать её&nbsp;учеником. Обычно это делается при: поступлении в&nbsp;школу, переводе из&nbsp;другого учебного заведения или для сдачи аттестаций и&nbsp;экзаменов ученикам на&nbsp;семейной форме. Для прикрепления к&nbsp;нашей школе необходимо подать заявление.
      </p>
    `,
  },
  {
    title: 'Как проходит прикрепление?',
    body: `
      <p>
        Для прикрепления к&nbsp;нашей онлайн-школе вам необходимо оставить заявку на&nbsp;сайте. Все остальное мы&nbsp;сделаем за&nbsp;вас. Просто как раз-два-три.
      </p>
    `,
  },
  {
    title: 'Какие документы нужны для прикрепления?',
    body: `
      <p>
        Вам понадобятся следующие документы: паспорт, аттестат об&nbsp;основном общем образовании (для 9&nbsp;классов), аттестат о&nbsp;среднем общем образовании (для 11&nbsp;классов).
      </p>
    `,
  },
  {
    title: 'Можно ли прикрепиться к онлайн-школе, если я живу в другом регионе?',
    body: `
      <p>
        Да, вы&nbsp;можете прикрепиться к&nbsp;нашей школе из&nbsp;любой точки мира полностью онлайн.
      </p>
    `,
  },
  {
    title: 'Могу ли я сдавать аттестации онлайн?',
    body: `
      <p>
        Да, аттестации проходят в&nbsp;установленные даты всегда онлайн на&nbsp;нашей платформе. Нужно будет сдать тесты и&nbsp;проверочные работы на&nbsp;платформе. Ученики сдают аттестацию без камер, в&nbsp;комфортной домашней атмосфере.
      </p>
    `,
  },
  {
    title: 'Сколько у меня есть времени на сдачу аттестации? ',
    body: `
      <p>
        Аттестация открыта на&nbsp;платформе около 2&nbsp;недель в&nbsp;период проведения, на&nbsp;выполнение работы по&nbsp;одному предмету дается 40&nbsp;минут.
      </p>
    `,
  },
  {
    title: 'Есть ли возможность пересдачи аттестации?',
    body: `
      <p>
        В&nbsp;случае неудовлетворительного результата аттестации у&nbsp;вас будет возможность её&nbsp;пересдать в&nbsp;указанные периоды.
      </p>
    `,
  },
];

export const vechernee = [
  {
    title: 'Как проходят занятия?',
    body: `
      <p>
        Учебный процесс включает лекции, семинары и&nbsp;практические занятия, направленные на&nbsp;освоение школьной программы, а&nbsp;также на&nbsp;подготовку к&nbsp;ОГЭ и&nbsp;ЕГЭ. Занятия в&nbsp;онлайн-школе &laquo;Синергия&raquo; проходят на&nbsp;образовательной платформе, где собрано все самое необходимое для учебы: записи занятий, домашние задания и&nbsp;бесплатные учебные материалы и&nbsp;курсы
      </p>
    `,
  },
  {
    title: 'Как происходит зачисление в вечернюю онлайн-школу?',
    body: `
      <p>
        Начать учебу в&nbsp;онлайн-школе &laquo;Синергия&raquo; можно в&nbsp;любое время, даже в&nbsp;середине учебного года. Для этого вам понадобится несколько шагов:
      </p>
       <ol>
         <li>Предупредите директора вашей школы о&nbsp;переходе.</li>
         <li>Оповестите о&nbsp;вашем решении государственные органы.</li>
         <li>Соберите пакет документов.</li>
         <li>Выберете школу, куда вы&nbsp;прикрепитесь. В&nbsp;ней ребенок будет сдавать экзамены и&nbsp;проходить аттестации. Для прикрепления вы&nbsp;всегда можете выбрать онлайн-школу &laquo;Синергия&raquo;.</li>
        </ol>
        <p>
          Чтобы получить подробную информацию о&nbsp;переходе на&nbsp;домашнее обучение, вы&nbsp;можете <button class="m-btn" data-modal="toggleLead2">оставить заявку</button> на&nbsp;нашем сайте. Наши специалисты ответят на&nbsp;все ваши вопросы.
        </p>
    `,
  },
  {
    title: 'Во сколько начинаются занятия?',
    body: `
      <p>
        Занятия в&nbsp;вечерней школе проходят в&nbsp;удобное для учащихся время. В&nbsp;онлайн-школе &laquo;Синергия&raquo; мы&nbsp;заботимся о&nbsp;том, чтобы наши ученики не&nbsp;пропускали занятия. Все уроки записываются и&nbsp;сохраняются на&nbsp;платформе школы, так что вы&nbsp;всегда сможете вернуться к&nbsp;материалу, если пропустили занятие.
      </p>
    `,
  },
  {
    title: 'Какие документы нужны для зачисления в вечернюю школу?',
    body: `
      <p>
        Чтобы поступить в&nbsp;онлайн-школу &laquo;Синергия&raquo;, вам понадобятся следующие документы: паспорт и/или свидетельство о&nbsp;рождении и&nbsp;документ об&nbsp;успеваемости ребёнка. Полный перечень документов вы&nbsp;можете узнать у&nbsp;кураторов, заполнив заявку на&nbsp;нашем сайте.
      </p>
    `,
  },
  {
    title: 'Можно совмещать работу с учебой?',
    body: `
      <p>
        Да, обучение в&nbsp;вечерней школе организовано так, чтобы его можно было совмещать с&nbsp;работой или другими обязанностями. На&nbsp;платформе онлайн-школы &laquo;Синергия&raquo; вы&nbsp;всегда сможете найти записи пройденных занятий, а&nbsp;также более 1000 <a href="/education">бесплатных материалов</a> и&nbsp;10&nbsp;000 интерактивных тренажёров для закрепления полученных знаний.
      </p>
    `,
  },
];

export const semeinoe = [
  {
    title: 'Как организовать учебный процесс?',
    body: `
      <p>
        Чтобы семейное обучение было эффективным, необходимо иметь гибкий учебный план. Онлайн-школа &laquo;Синергия&raquo; предлагает индивидуальный подход к&nbsp;организации учебного процесса для каждого ученика. Для каждого ученика составляется индивидуальный план обучения, который учитывает его уровень знаний и&nbsp;скорость усвоения материала. Преподаватели регулярно оценивают успехи учеников и&nbsp;предлагают дополнительные материалы и&nbsp;советы для улучшения результатов.
      </p>
    `,
  },
  {
    title: 'Как выбрать учебные материалы для обучения',
    body: `
      <p>
        Семейное образование позволяет учиться с&nbsp;использованием различных ресурсов: учебников, онлайн-курсов, интерактивных приложений и&nbsp;видеоуроков. Также можно воспользоваться услугами онлайн-школы &laquo;Синергия&raquo;. На&nbsp;платформе школы собраны 1000 <a href="/education">бесплатных учебных материалов</a> и&nbsp;курсов и&nbsp;интерактивных тренажёров.
      </p>
    `,
  },
  {
    title: 'Какие документы нужны для перехода?',
    body: `
      <p>
        Чтобы перевести ребёнка в&nbsp;онлайн-школу &laquo;Синергия&raquo;, нужно собрать следующие документы: заявление о&nbsp;переходе на&nbsp;семейное обучение, паспорта родителя и&nbsp;ребёнка, свидетельство о&nbsp;рождении ребёнка, СНИЛС, личную карту и&nbsp;документ, подтверждающий успеваемость ребёнка. Полный список вы&nbsp;можете узнать у&nbsp;наших менеджеров. Для этого оставьте свою заявку на&nbsp;сайте и&nbsp;специалисты свяжутся с&nbsp;вами.
      </p>
    `,
  },
  {
    title: 'Что делать с социализацией ребенка?',
    body: `
      <p>
        Чтобы ребёнок мог успешно социализироваться, важно предоставить ему возможность участвовать в&nbsp;различных групповых активностях. Это могут быть кружки по&nbsp;интересам, спортивные секции, творческие мастерские или общественные мероприятия, на&nbsp;которых ребёнок сможет общаться с&nbsp;другими детьми. В&nbsp;онлайн-школе &laquo;Синергия&raquo; мы&nbsp;создаём благоприятные условия для общения учеников. Во&nbsp;внеурочное время ребята могут продолжать общаться в&nbsp;мессенджерах или встречаться лично. Наши кураторы регулярно организовывают для учеников интересные мероприятия. Например, поход в&nbsp;зоопарк, мастер-классы по&nbsp;рисованию от&nbsp;педагогов и&nbsp;походы в&nbsp;музеи. А&nbsp;в&nbsp;конце обучения каждый может прийти на&nbsp;настоящий выпускной.
      </p>
    `,
  },
  {
    title: 'Как перейти на семейное обучение?',
    body: `
      <p>
        Сначала сообщите о&nbsp;своём решении директору вашей школы. Затем, направьте уведомление в&nbsp;Департамент образования города или округа. После этого выберите школу, в&nbsp;которой вы&nbsp;будете проходить аттестации и&nbsp;экзамены. Для закрепления вы&nbsp;можете выбрать онлайн-школу &laquo;Синергия&raquo;, мы&nbsp;будем рады вам помочь.
      </p>
    `,
  },
  {
    title: 'Какой будет аттестат после семейного образования?',
    body: `
      <p>
        &laquo;Синергия&raquo;&nbsp;&mdash; это аккредитованное учебное заведение. Вы&nbsp;можете увидеть подтверждение аккредитации на&nbsp;<button class="m-btn" data-function="openLicenses">нашем сайте</button>. Наши преподаватели разрабатывают программу обучения в&nbsp;соответствии с&nbsp;российскими образовательными стандартами&nbsp;&mdash; ФГОС и&nbsp;ФООП. По&nbsp;окончании обучения и&nbsp;успешной сдачи экзаменов каждый выпускник получает аттестат государственного образца, который ничем не&nbsp;отличается от&nbsp;обычного.
      </p>
    `,
  },
];

export default {
  school,
  tutors,
  oge,
  ege,
  external,
  softSkills,
  finalEssay,
  finalInterview,
  repetitor,
  programmirovanie,
  externalAdult,
  externalNew,
  zaochnoe,
  attestacii,
  vechernee,
  semeinoe,
};
